import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AbonnementPage } from './abonnement';

@NgModule({
  declarations: [
    AbonnementPage,
  ],
  imports: [
    IonicPageModule.forChild(AbonnementPage),
  ],
})
export class AbonnementPageModule {}



// WEBPACK FOOTER //
// ./src/pages/abonnement/abonnement.module.ts